import ButtonWithIcon from "./ButtonWithIcon.jsx";
import PropTypes from "prop-types";
import {Icons} from "./Icons.jsx";
import useCopyToClipboard from "../../hooks/useCopyToClipboard.js";

export const CopyDataToClipboard = ({data, text, size = 28, variant = 'link'}) => {


    const [_clipboardPayload, copy] = useCopyToClipboard();

    const columnNames = Object.keys(data[0] || {})
    const transformedData = [
        columnNames,
        ...data.map(obj => columnNames.map(key => obj[key]))
    ];
    const csvOutput = transformedData.map(row => row.join(',')).join('\n');

    if (text) return (
        <div onClick={() => copy(csvOutput)}>
            {text}
        </div>
    )


    return (
        <ButtonWithIcon
            icon={<Icons.copy size={size}/>}
            title={'Kopiuj dane do schowka'}
            variant={variant}
            onClick={() => copy(csvOutput)}
        />
    );
}

CopyDataToClipboard.propTypes = {
    data: PropTypes.array.isRequired,
    size: PropTypes.number,
    variant: PropTypes.string,
    text: PropTypes.string,
};